import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { PlayerSelection } from '../../../components/playerSelection/playerSelection';
import { di } from '../../../state/inversify.config';
import { AssessmentQueryParamService } from './assessment.queryParam.service';
import { TakeAssessment } from './takeAssessment/takeAssessment';
import { AssessmentCreationViewService } from './assessmentCreationView/assessmentCreation.view.service';
import { AuthService } from '../../../state/helperServices/auth/auth.service';
import { Button } from '../../../components/button/button';

export function StartAssessment() {
  const { t } = useTranslation();

  const assessmentQueryParamService = di.get<AssessmentQueryParamService>(
    AssessmentQueryParamService,
  );
  const queryParams = assessmentQueryParamService.useSelectMergedQuery();

  const assessmentCreationViewService = di.get<AssessmentCreationViewService>(
    AssessmentCreationViewService,
  );

  // TODO: move into a domainService and only return accountType or even better find a way so that you don't have to send down the accountType
  const authService = di.get<AuthService>(AuthService);
  const loggedInUser = authService.useLoggedInUserSelector();

  const [startAssessment, setStartAssessment] = useState(false);

  const shouldResumeAssessment =
    queryParams.activeStep && queryParams.activeStep > 1;

  const resumeAssessment = (): void => {
    setStartAssessment(true);
  };

  const resetAndStartAssessment = (): void => {
    assessmentCreationViewService.dispatchResetAssessment();
    setStartAssessment(true);
  };

  const onSelect = (playerId: string) => {
    assessmentQueryParamService.dispatchQueryParams({
      selectedPlayerId: playerId,
      activeStep: 1,
    });
  };

  return (
    <>
      {startAssessment ? (
        <TakeAssessment />
      ) : (
        <Grid>
          <PlayerSelection
            onSelect={onSelect}
            accountType={loggedInUser?.accountType}
            selectedPlayer={queryParams.selectedPlayerId}
          />
          {queryParams.selectedPlayerId && (
            <Button
              type="submit"
              color="secondary"
              variant="contained"
              fullWidth
              size="medium"
              label={
                shouldResumeAssessment
                  ? `${t('RESUME_ASSESSMENT')}`
                  : `${t('START_ASSESSMENT')}`
              }
              onClick={
                shouldResumeAssessment
                  ? resumeAssessment
                  : resetAndStartAssessment
              }
              sx={{ my: 2 }}
            />
          )}
        </Grid>
      )}
    </>
  );
}
